import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Vuex from 'vuex'
import Icon from 'vue-awesome/components/Icon.vue'
import InfiniteScroll from 'vue-infinite-scroll'
import VueProgressBar from 'vue-progressbar'

import 'bulma/bulma.sass'
/**
 * Общие стили
 */
import './resources/sass/style.scss'

global.Vue = Vue

Vue.use(VueI18n)
Vue.component('icon', Icon)
Vue.use(InfiniteScroll)

Vue.use(Vuex)
global.Vuex = Vuex

Vue.use(VueProgressBar, {
  color: '#00d1b2',
  failedColor: '#ff2b56',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
})



// WEBPACK FOOTER //
// ./resources/assets/site/bootstrap.js